<template>
  <div class="login-background">
    <div id="login">
      <img class="logo" src="../assets/logo.png" alt="logo" />
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="login-form"
        @keyup.enter.native="onSubmit"
      >
        <img
          class="form-img"
          src="../assets/GavialData DAMP.png"
          alt="form-img"
        />
        <el-form-item prop="userName">
          <el-input
            class="login-input"
            v-model="ruleForm.userName"
            auto-complete="off"
            prefix-icon="el-icon-ga-username"
            placeholder="用户名"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            class="login-input"
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            prefix-icon="el-icon-ga-passward"
            placeholder="密码"
          >
          </el-input>
        </el-form-item>
        <el-button type="primary" class="login-button" @click="onSubmit"
          >登陆</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  name: "login",
  data() {
    return {
      showMessage: false,
      ruleForm: {
        userName: "",
        password: ""
      },
      rules: {
        userName: [
          {
            required: true,
            message: "请输入账户",
            trigger: "change"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "change"
          }
        ]
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    if (this.$store.state.userInfo !== null) {
      next();
    } else {
      next(false);
    }
  },
  created() {
    this.$store.dispatch("setMenuState", false);
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.login();
        }
      });
    },
    login() {
      this.$http({
        url: "/j_spring_security_check",
        method: "post",
        data: {
          j_username: this.ruleForm.userName,
          j_password: this.ruleForm.password
        },
        transformRequest: [
          function(data) {
            let form = "";
            for (let it in data) {
              form += `${encodeURIComponent(it)}=${encodeURIComponent(
                data[it]
              )}&`;
            }
            return form;
          }
        ],
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(res => {
          // 保存用户登录表单，notebook登录需要用
          this.$store.dispatch("setLoginForm", this.ruleForm);
          localStorage.loginForm = JSON.stringify(this.ruleForm);
          this.$store.dispatch("setUserInfo", res.data);
          localStorage.userInfo = JSON.stringify(res.data);
          this.$router.push({ name: "home" });
        })
        .catch(() => {
          if (this.showMessage) return;
          this.showMessage = true;
          this.$message({
            type: "error",
            message: "用户名或密码错误",
            duration: 2000
          });
          setTimeout(() => {
            this.showMessage = false;
          }, 2200);
        });
    }
  }
};
</script>

<style lang="scss">
.login-background {
  height: inherit;
  width: inherit;
  background: #f0f2f5;
}
#login {
  height: inherit;
  width: inherit;
  background: url("../assets/background.jpg") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .logo {
    width: 240px;
    position: fixed;
    left: 180px;
    top: 33px;
  }
  .login-form {
    width: 350px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    i {
      font-size: 20px;
      padding: 0 5px;
    }
    .login-button {
      width: 100%;
    }
    .el-form-item {
      margin-bottom: 30px;
    }
    .form-img {
      // transform: translateX(-25%);
      opacity: 0.5;
      width: 600px;
      position: relative;
      top: -80px;
      left: -125px;
    }
  }
  .login-input .el-input__inner {
    background: rgba(78, 92, 114, 0.3);
    border-color: rgba(212, 212, 212, 0.3);
    color: #fff;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  .el-form-item__error {
    right: 0;
    left: inherit;
  }
}
</style>
